import { useParams } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Calendar, Clock } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function OneOnOneSchedulePlaceholder() {
  const { userId } = useParams<{ userId: string }>()

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-3xl mx-auto space-y-6">
        <header className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">Schedule a 1-on-1</h1>
          <p className="text-muted-foreground">
            Participant ID: <span className="font-mono">{userId}</span>
          </p>
        </header>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <Calendar className="h-5 w-5 text-primary" />
              Scheduling form pending port
            </CardTitle>
            <CardDescription>
              The date picker, template selection, and reminder settings need to be migrated from the Next.js app to finish this
              workflow in Vite.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="rounded-xl bg-muted/40 border border-border p-4 text-sm text-muted-foreground flex items-start gap-3">
              <Clock className="h-5 w-5 text-muted-foreground" />
              <span>
                Until the migration is complete, schedule sessions from the existing dashboard list view or continue using the
                legacy interface.
              </span>
            </div>
            <div className="flex gap-3">
              <Button asChild>
                <Link to="/dashboard/one-on-ones">Back to sessions</Link>
              </Button>
              <Button asChild variant="outline">
                <Link to="/dashboard/one-on-ones/create">Create quick session</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
